<template>
  <div class="feedback-table">
    <div class="name">{{name}}</div>
    <div class="company">{{company}}</div>
    <div class="step"><el-tag size="mini" style="cursor:pointer" @click.native="showRadishProgress">{{tag}}</el-tag></div>
    <div class="date">{{date}}</div>
  </div>
</template>

<script>
export default {
  props: {
    name: { type: String, default: '--' },
    company: { type: String, default: '--' },
    tag: { type: String, default: '--' },
    date: { type: String, default: '--' },
    rid: { type: String, default: '' },
  },
  data() {
    return {}
  },
  methods: {
    showRadishProgress() {
      this.$emit('showRadishProgress', this.rid)
    },
  },
}
</script>
<style scoped>
.feedback-table {
  display: flex;
  border: 1px solid #eeeeee;
  align-items: center;
  width: 400px;
  margin: 0 50px 10px 0;
  background-color: #fff;
  border-radius: 5px;
}
.name,
.company,
.step,
.date {
  padding: 4px 0;
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
}
.name,
.company,
.step {
  border-right: 1px solid #eeeeee;
}

.name,
.date {
  flex: 1;
}
.step,
.company {
  flex: 2;
}
</style>
